import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useHistory, useParams } from "react-router-dom";
import { baseUrl } from "../../config";
import { UploadOutlined } from '@ant-design/icons';
import moment from 'moment';
import userDummy from "../../assets/images/dummy-user.png";
import { getPermissions, hasPermission } from '../../components/permissions';


import {
  Row, Col, Card, Button, Tabs, List, Descriptions, Avatar, Radio, Switch, Upload, message, notification, Select, Typography, Form, Modal
} from "antd";

import {
  FacebookOutlined,
  TwitterOutlined,
  InstagramOutlined,
  VerticalAlignTopOutlined, UserOutlined
} from "@ant-design/icons";

import BgProfile from "../../assets/images/bg-profile.jpg";
import profilavatar from "../../assets/images/face-1.jpg";
import convesionImg from "../../assets/images/face-3.jpg";
import convesionImg2 from "../../assets/images/face-4.jpg";
import convesionImg3 from "../../assets/images/face-5.jpeg";
import convesionImg4 from "../../assets/images/face-6.jpeg";
import convesionImg5 from "../../assets/images/face-2.jpg";
import project1 from "../../assets/images/home-decor-1.jpeg";
import project2 from "../../assets/images/home-decor-2.jpeg";
import project3 from "../../assets/images/home-decor-3.jpeg";
import Invoice from "../../components/Invoice";
import InvoiceView from "../../components/InvoiceView";

const { Title } = Typography;
const { Item } = Form;
const { Option } = Select;

function ViewPayments({ paymentId: paymentIdProp } = {}) {

  const [imageURL, setImageURL] = useState(false);
  const [, setLoading] = useState(false);

  const params = useParams();
  const id = paymentIdProp || params.id; // Accept prop or URL param
  const history = useHistory();
  const [form] = Form.useForm();
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [userData, setUserData] = useState({});
  const printRef = useRef();



  useEffect(() => {
    // Check if id exists to determine if it's an update mode
    if (id) {
      fetchUserDetails();
    }
  }, [id]);

  const fetchUserDetails = async () => {
    try {
      const response = await axios.get(`${baseUrl}/payments/read/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`, // Include access token in headers
        },
      });
      if (response.status === 200) {
        // setRoleData(response.data.result);
        setUserData(response.data.result);
      } else {
        notification.info({
          message: 'Info',
          description: response.data.message,
          placement: 'topRight'
        });
      }
    } catch (error) {
      console.error("API error:", error);
      notification.info({
        message: 'Info',
        description: error.response?.data?.message,
        placement: 'topRight'
      });
    }
  };


  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  };

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("Image must smaller than 2MB!");
    }
    return isJpgOrPng && isLt2M;
  };

  const handleChange = (info) => {
    if (info.file.status === "uploading") {
      setLoading(false);
      return;
    }
    if (info.file.status === "done") {
      getBase64(info.file.originFileObj, (imageUrl) => {
        setLoading(false);
        setImageURL(false);
      });
    }
  };

  //For show image on model larges
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentImage, setCurrentImage] = useState("");
  const [isInvoiceModal, setIsInvoiceModal] = useState(false);

  const showModalInvoice = (image) => {
    setIsInvoiceModal(true);
  };

  const handleCancelInvoice = () => {
    setIsInvoiceModal(false);
  };

  const showModal = (image) => {
    setCurrentImage(image || userDummy);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const pencil = [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        d="M13.5858 3.58579C14.3668 2.80474 15.6332 2.80474 16.4142 3.58579C17.1953 4.36683 17.1953 5.63316 16.4142 6.41421L15.6213 7.20711L12.7929 4.37868L13.5858 3.58579Z"
        className="fill-gray-7"
      ></path>
      <path
        d="M11.3787 5.79289L3 14.1716V17H5.82842L14.2071 8.62132L11.3787 5.79289Z"
        className="fill-gray-7"
      ></path>
    </svg>,
  ];

  const uploadButton = (
    <div className="ant-upload-text font-semibold text-dark">
      {<VerticalAlignTopOutlined style={{ width: 20, color: "#000" }} />}
      <div>Upload New Project</div>
    </div>
  );

  const handlePrint = () => {
    const printContents = printRef.current.innerHTML;
    const originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
  };


  const handleVerifyPayment = async (paymentId) => {
    Modal.confirm({
      title: 'Are you sure you want to verify this payment?',
      onOk: async () => {
        try {
          const response = await axios.patch(`${baseUrl}/payments/paymentStatusVerify/${paymentId}`, { payment_virify: 'verified' }, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('accessToken')}`, // Include access token in headers
            },
          });

          if (response.status === 200) {
            fetchUserDetails();
            notification.success({
              message: 'Success',
              description: 'Payment verified successfully',
              placement: 'topRight',
              duration: 1.5
            });
          }
        } catch (error) {
          notification.info({
            message: 'Info',
            description: "Failed to verify payment",
            placement: 'topRight'
          });

        }
      },
    });
  }


  const statusColor = userData.payment_virify === 'verified' ? '#52c41a' : userData.payment_virify === 'failed' ? '#ff4d4f' : '#faad14';
  const statusText = userData.payment_virify === 'verified' ? 'Verified' : userData.payment_virify === 'failed' ? 'Failed' : 'Pending';

  const InfoRow = ({ label, value, highlight }) => (
    <div style={{ display: 'flex', padding: '6px 14px', borderBottom: '1px solid #f0f3f7', alignItems: 'flex-start' }}>
      <span style={{ minWidth: 140, color: '#6b7b8d', fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.3, flexShrink: 0, paddingTop: 1 }}>{label}</span>
      <span style={{ color: highlight ? highlight : '#7a0000', fontSize: 13, fontWeight: 500, flex: 1 }}>{value || <span style={{ color: '#bbb' }}>—</span>}</span>
    </div>
  );

  return (
    <>
      <div style={{ background: '#fff', borderRadius: 8, border: '1px solid #dde3ee', overflow: 'hidden', margin: '0 2px' }}>

        {/* ── Header ── */}
        <div style={{ background: '#7a0000', padding: '10px 14px', display: 'flex', alignItems: 'center', gap: 12 }}>
          <Avatar
            shape="square"
            size={48}
            src={userData.profile_img || userDummy}
            icon={!userData.profile_img && <UserOutlined />}
            onClick={() => showModal(userData.profile_img || userDummy)}
            style={{ cursor: 'pointer', borderRadius: 6, border: '2px solid rgba(255,255,255,0.4)', flexShrink: 0 }}
          />
          <div>
            <div style={{ color: '#fff', fontWeight: 700, fontSize: 15, lineHeight: 1.3 }}>{userData.name_eng || '—'}</div>
            <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12 }}>{userData.phone_no || ''}</div>
          </div>
          <div style={{ marginLeft: 'auto' }}>
            <span style={{ display: 'inline-block', padding: '3px 12px', borderRadius: 20, background: statusColor, color: '#fff', fontWeight: 700, fontSize: 12 }}>
              {statusText}
            </span>
          </div>
        </div>

        {/* ── Payment Details ── */}
        <div style={{ background: '#f5f7fa', padding: '6px 14px', borderBottom: '1px solid #e8edf4', borderTop: '1px solid #e8edf4' }}>
          <span style={{ color: '#7a0000', fontWeight: 700, fontSize: 11, textTransform: 'uppercase', letterSpacing: 0.5 }}>Payment Details</span>
        </div>

        <InfoRow label="Account" value={userData.bank_account} />
        {userData.special_occassion_category && <InfoRow label="Special Occasion" value={userData.special_occassion_category} />}
        <InfoRow label="Amount (Rs)" value={userData.amount ? `Rs.${userData.amount}` : null} highlight="#7a0000" />
        <InfoRow label="Txn Detail (UTR/ID)" value={userData.utr_number} />
        <InfoRow label="Txn Date" value={userData.transaction_date ? moment(userData.transaction_date).format('DD MMM YYYY') : null} />
        <InfoRow label="Mode of Payment" value={userData.pyament_mode_type} />
        <InfoRow label="Pay Entry Date" value={userData.payment_entry_date ? moment(userData.payment_entry_date).format('DD MMM YYYY') : null} />
        <InfoRow label="Remark" value={userData.remarks} />

        {hasPermission('/payments', 'editPermission') && (
          <div style={{ display: 'flex', padding: '8px 14px', borderBottom: '1px solid #f0f3f7', alignItems: 'center' }}>
            <span style={{ minWidth: 140, color: '#6b7b8d', fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.3 }}>Payment Status</span>
            {(userData.payment_virify === 'pending' || userData.payment_virify === 'failed') && (
              <button onClick={() => handleVerifyPayment(userData.payment_id)} style={{ padding: '4px 14px', background: userData.payment_virify === 'failed' ? '#ff4d4f' : '#faad14', color: '#fff', border: 'none', borderRadius: 5, fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>
                {statusText} — Click to Verify
              </button>
            )}
            {userData.payment_virify === 'verified' && (
              <span style={{ display: 'inline-block', padding: '3px 12px', borderRadius: 5, background: '#52c41a', color: '#fff', fontWeight: 700, fontSize: 12 }}>Verified</span>
            )}
          </div>
        )}

        {/* ── SHIKSHA NIDHI ── */}
        {userData.account_id && userData.account_id == 1 && (
          <>
            <div style={{ background: '#f5f7fa', padding: '6px 14px', borderBottom: '1px solid #e8edf4', borderTop: '1px solid #e8edf4', marginTop: 4 }}>
              <span style={{ color: '#7a0000', fontWeight: 700, fontSize: 11, textTransform: 'uppercase', letterSpacing: 0.5 }}>Shiksha Nidhi</span>
            </div>

            {['Cash', 'Website-Razorpay', 'Application-Razorpay'].includes(userData?.pyament_mode_type) ? (
              <>
                <InfoRow label="E-Receipt No" value={userData.e_reciept_no} />
                <InfoRow label="E-Receipt Date" value={userData.e_reciept_date ? moment(userData.e_reciept_date).format('DD MMM YYYY') : null} />
              </>
            ) : (
              <InfoRow label="Receipt No." value={userData.receipt_no || '-'} />
            )}

            <InfoRow label="Month Covered Start" value={userData.start_month ? moment(userData.start_month).format('DD MMM YYYY') : null} />
            <InfoRow label="Month Covered End" value={userData.end_month ? moment(userData.end_month).add(1, 'months').format('DD MMM YYYY') : null} />
            <InfoRow label="Duration (Months)" value={userData.duration_type} />
            <InfoRow label="Monthly Share (Rs)" value={userData.month_share_amount ? `Rs.${userData.month_share_amount}` : null} />
          </>
        )}

        {/* ── Invoice Actions ── */}
        {userData?.account_id === 1 && userData?.payment_virify === 'verified' &&
          !['Cash', 'Website-Razorpay', 'Application-Razorpay'].includes(userData?.pyament_mode_type) && (
          <div style={{ padding: '10px 14px', borderTop: '1px solid #e8edf4', display: 'flex', gap: 8 }}>
            <button onClick={showModalInvoice} style={{ padding: '5px 14px', background: '#7a0000', color: '#fff', border: 'none', borderRadius: 5, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
              View Invoice
            </button>
            <Invoice paymentId={id} btnShow={['img_download', 'pdf_download', 'pdf_print', 'whatsapp']} />
          </div>
        )}

      </div>



      <Modal
        open={isInvoiceModal}
        footer={null}
        onCancel={handleCancelInvoice}
        width={767}
        closeIcon={null}
      >
        <InvoiceView paymentId={id} displayView="block" />
      </Modal>

      <Modal
        open={isModalVisible}
        footer={null}
        onCancel={handleCancel}
      >
        <img
          src={currentImage}
          alt="Profile"
          style={{ width: '100%' }}
        />
      </Modal>
    </>
  );
}

export default ViewPayments;
